import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const MapPinFilledIcon = props => {
  return (
    <Svg
      width={18}
      height={21}
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.774 7.377A8.038 8.038 0 018.784 0h.432a8.038 8.038 0 018.01 7.377 8.693 8.693 0 01-1.933 6.217L10.5 19.456a1.937 1.937 0 01-3 0l-4.792-5.862A8.693 8.693 0 01.774 7.377zM12.53 7.03a.75.75 0 00-1.06-1.06L8.5 8.94 7.03 7.47a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default MapPinFilledIcon;
